import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Tools|Review Tool|Exam Items';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSecurity,
	portal: 'SP',
};
const columnHeadingStart = 'Column heading start: ';

type LocNameStart = 'SPReviewToolExamItems';
export type SPReviewToolExamItemsLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}LabelId`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelScored`
	| `${LocNameStart}LabelTimeSpent`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelOrderPresented`
	| `${LocNameStart}LabelSection`
	| `${LocNameStart}LabelDistractorCount`
	| `${LocNameStart}LabelResponseType`
	| `${LocNameStart}LabelResponse`
	| `${LocNameStart}LabelKey`;

export const spReviewToolExamItemsLocs: LocDefs<SPReviewToolExamItemsLocNames> = {
	SPReviewToolExamItemsTitleSection: {
		defaultValue: 'Item Details',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Title.ItemDetailsSection',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelId: {
		defaultValue: 'ID',
		description: `${columnHeadingStart}ID.`,
		displayPath: `${pathStart}ID`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.ItemDetailsId',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelName: {
		defaultValue: 'Name',
		description: `${columnHeadingStart}Name.`,
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.Name',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelScored: {
		defaultValue: 'Scored',
		description: `${columnHeadingStart}Scored.`,
		displayPath: `${pathStart}Scored`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.ScoredDisplay',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelTimeSpent: {
		defaultValue: 'Time Spent',
		description: `${columnHeadingStart}Time Spent.`,
		displayPath: `${pathStart}Time Spent`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.TimeSpentStr',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelStatus: {
		defaultValue: 'Status',
		description: `${columnHeadingStart}Status.`,
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.Status',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelOrderPresented: {
		defaultValue: 'Order Presented',
		description: `${columnHeadingStart}Order Presented.`,
		displayPath: `${pathStart}Order Presented`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.OrderPresented',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelSection: {
		defaultValue: 'Section(s)',
		description: `${columnHeadingStart}Section(s).`,
		displayPath: `${pathStart}Section(s)`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.SectionOrdinal',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelDistractorCount: {
		defaultValue: 'Distractor Count',
		description: `${columnHeadingStart}Distractor Count.`,
		displayPath: `${pathStart}Distractor Count`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.DistractorCount',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelResponseType: {
		defaultValue: 'Response Type',
		description: `${columnHeadingStart}Response Type.`,
		displayPath: `${pathStart}Response Type`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.ResponseType',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelResponse: {
		defaultValue: 'Response',
		description: `${columnHeadingStart}Response.`,
		displayPath: `${pathStart}Response`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.Response',
		...sharedProperties,
	},
	SPReviewToolExamItemsLabelKey: {
		defaultValue: 'Key',
		description: `${columnHeadingStart}Key.`,
		displayPath: `${pathStart}Key`,
		displayType: 'Label',
		legacyName: 'Exam.Security/Tools.ExamReviewTool.Content.CorrectAnswer',
		...sharedProperties,
	},
};

export type SPReviewToolExamItemsLocType = LocMap<SPReviewToolExamItemsLocNames>;
